module.exports = `${require.publicPath}icon13.4af86715.png`;